import { format } from 'date-fns';
import { FunctionComponent, memo, useMemo } from 'react';
import { DATE_TIME_FORMAT } from '../../constants';
import { getCssVar } from '../../utils';
import { IconLabel, IconLabelHintDirection } from '../IconLabel';

import classNames from 'classnames';

interface ScheduleIconProps {
  time: Date | string | null;
  label?: string;
  hint?: string;
  hintDirection?: IconLabelHintDirection;
  className?: string;
  disabled?: boolean;
  nonClickable?: boolean;
  onClick?: () => void;
}

export const ScheduleIcon: FunctionComponent<ScheduleIconProps> = memo(
  ({
    time,
    label,
    hint,
    hintDirection = IconLabelHintDirection.top,
    className,
    disabled,
    nonClickable,
    onClick,
  }) => {
    const data = useMemo(() => {
      if (!time) {
        return hint;
      }

      return format(new Date(time), DATE_TIME_FORMAT);
    }, [hint, time]);

    return (
      <IconLabel
        label={label}
        className={classNames(className)}
        iconId={`calendar-${time ? 'added' : 'add'}`}
        color={getCssVar('--schedule-icon-color')}
        hoverColor={getCssVar('--schedule-icon-hover-color')}
        data={data}
        hintDirection={hintDirection}
        disabled={disabled}
        nonClickable={nonClickable}
        onClick={onClick}
        {...(Boolean(time && hint) && { ariaLabel: `${hint}, ${data}` })}
      />
    );
  }
);
